import React, { Component } from "react";
import YouTube from "react-youtube";
import { getServices } from "../method/service";
import HomeCars from "../widget/home_cars";
// import HomeCars from "../widget/home_cars";
import HomeFooter from "../widget/home_footer";
import HomeQuestions from "../widget/home_questions";
import { Header, HomeTop } from "../widget/home_top";
import { EnquiryPopup } from "../widget/popups";
import ServiceBanner from "../widget/ServiceBanner";
import ServiceAll from "../widget/service_all";
import ServiceBodyHeader from "../widget/service_body_header";
import { ErrorPage, LoadingPage } from "../widget/warning_page";

export default class Service extends Component {
  constructor() {
    super();
    this.state = {
      services: [],
      service: null,
      loading: true,
      error: null,
      seasonCars: [],
      homeSearchs: [],
      locations_h: [],
      locations_b: [],
      locations_m: [],
      locations_c: [],
      locations_r: [],
      banners: [],
      location: {},
      faq: [],
      enquiryPopup: null,
      youtubeLink: "",
      dynamic_links: [],
    };
  }

  componentDidMount() {
    getServices(this);
  }

  render() {
    const { loading, error, youtubeLink } = this.state;
    if (loading) return <LoadingPage />;
    // if (error != null) return <ErrorPage />;
    return (
      <React.StrictMode>
        <Header props={this} />

        {/* <HomeTop props={this} /> */}
        {/* HomeTop component is used for both home page banner and service page banner based on location showing the content */}

        <ServiceBanner props={this} />
        {/* ServiceBanner component is the replacement of HomeTop component, created a different banner section not related to location data, for all location it will show same data */}

        {/* {console.log(this.state.services)} */}

        <ServiceBodyHeader props={this} />
        <ServiceAll props={this} />
        {/* <HomeSecurity /> */}
        <YouTube videoId={youtubeLink} className="service_youtube" />
        <HomeQuestions props={this} />

        <HomeCars props={this} />

        {/* <HomeMunsoon /> */}
        <HomeFooter props={this} />
        <EnquiryPopup props={this} />
      </React.StrictMode>
    );
  }
}
